import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex items-center bg-white overflow-hidden" data-id="element-77">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-78">
        <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-blue-100/30 rounded-full blur-3xl" data-id="element-79" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 sm:pt-32 pb-10 sm:pb-12" data-id="element-80">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-81">
          {/* Left column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-82">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 mb-6 leading-[1.1]" data-id="element-83">
              Manda fotos y textos por WhatsApp.{' '}
              <span className="text-blue-600" data-id="element-84">
                Quedan ordenados y respaldados para siempre.
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-85">
              Obra Digital respalda y ordena todo lo que pasa en el WhatsApp de
              tu obra. Búsqueda instantánea. Resúmenes automáticos. Reportes
              cuando los necesites. Sin apps nuevas.
            </p>

            {/* Feature bullets */}
            <div className="space-y-3 mb-10" data-id="element-86">
              {['Toda tu info de obra respaldada y ordenada automáticamente', 'Busca cualquier foto, mensaje o decisión en segundos', 'Arma reportes para el mandante con un click'].map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2 + index * 0.1
            }} className="flex items-start" data-id="element-87">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-88" />
                  <span className="text-gray-700 font-medium" data-id="element-89">{feature}</span>
                </motion.div>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-90">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl" data-id="element-91">
                Probar con mi obra
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-92" />
              </button>
              <a href="#" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold text-blue-600 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors" data-id="element-93">
                Ver un reporte de ejemplo
              </a>
            </div>
          </motion.div>

          {/* Right column - Dashboard mockup illustration */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-94">
            {/* Browser mockup with dashboard */}
            <div className="relative bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden" data-id="element-95">
              {/* Browser chrome */}
              <div className="bg-gray-100 px-4 py-3 border-b border-gray-200 flex items-center gap-2" data-id="element-96">
                <div className="flex gap-1.5" data-id="element-97">
                  <div className="w-3 h-3 rounded-full bg-red-400" data-id="element-98" />
                  <div className="w-3 h-3 rounded-full bg-yellow-400" data-id="element-99" />
                  <div className="w-3 h-3 rounded-full bg-green-400" data-id="element-100" />
                </div>
                <div className="flex-1 ml-4 bg-white rounded-md px-3 py-1 text-xs text-gray-500" data-id="element-101">
                  app.obradigital.cl
                </div>
              </div>

              {/* Dashboard content */}
              <div className="p-6 bg-gradient-to-br from-gray-50 to-white" data-id="element-102">
                {/* Header */}
                <div className="mb-6" data-id="element-103">
                  <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-104">
                    Proyecto Centro · Semana 3 oct
                  </h3>
                </div>

                {/* KPI cards */}
                <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-105">
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-106">
                    <div className="text-2xl font-bold text-blue-600 mb-1" data-id="element-107">
                      12
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-108">
                      Avances
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-109">
                    <div className="text-2xl font-bold text-green-600 mb-1" data-id="element-110">
                      3
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-111">
                      Decisiones
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-112">
                    <div className="text-2xl font-bold text-amber-600 mb-1" data-id="element-113">
                      2
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-114">
                      Problemas
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-115">
                    <div className="text-2xl font-bold text-purple-600 mb-1" data-id="element-116">
                      5
                    </div>
                    <div className="text-xs text-gray-600 font-medium" data-id="element-117">
                      Pendientes
                    </div>
                  </div>
                </div>

                {/* Executive summary */}
                <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm mb-4" data-id="element-118">
                  <h4 className="text-sm font-bold text-gray-900 mb-2" data-id="element-119">
                    Resumen de la semana
                  </h4>
                  <div className="space-y-1.5 text-xs text-gray-600 leading-relaxed" data-id="element-120">
                    <p data-id="element-121">Se indica que avance es de un 18% en losa piso 3.</p>
                    <p data-id="element-122">Decisión de cambiar proveedor de fierros.</p>
                    <p data-id="element-123">Retraso de 2 días por lluvia.</p>
                  </div>
                </div>

                {/* Key decisions */}
                <div className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm" data-id="element-124">
                  <h4 className="text-sm font-bold text-gray-900 mb-3" data-id="element-125">
                    Decisiones clave
                  </h4>
                  <div className="space-y-2.5" data-id="element-126">
                    <div className="flex items-center gap-2.5" data-id="element-127">
                      <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center text-xs font-bold text-blue-700" data-id="element-128">
                        JM
                      </div>
                      <div className="flex-1 text-xs text-gray-700" data-id="element-129">
                        Cambio de proveedor aprobado
                      </div>
                      <div className="text-[10px] text-gray-400" data-id="element-130">Mar 12</div>
                    </div>
                    <div className="flex items-center gap-2.5" data-id="element-131">
                      <div className="w-7 h-7 rounded-full bg-green-100 flex items-center justify-center text-xs font-bold text-green-700" data-id="element-132">
                        PC
                      </div>
                      <div className="flex-1 text-xs text-gray-700" data-id="element-133">
                        Inspección programada viernes
                      </div>
                      <div className="text-[10px] text-gray-400" data-id="element-134">Mié 13</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating blue blur */}
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-blue-400/20 rounded-full blur-3xl -z-10" data-id="element-135" />
          </motion.div>
        </div>
      </div>
    </section>;
}